import Vue from "vue";
import Router from "vue-router";
import { Login, ForgetPassword, ChangePassword } from "@/views";
import {
	Register,
	RegisterNew,
	RegisterConfirm,
	RegisterProfile
} from "@/views";
import {
	SignUp,
	StartSignUp,
	SetUpUnder18,
	SetUpUpper18,
	SetUpPassword,
	EditStory
} from "@/views";
import {
	Challenge,
	PersonInfo,
	MyDFC,
	FreeResource,
	HistoryStories
} from "@/views";
import {
	BackendManage,
	StoriesManage,
	ManageStory,
	UploadYoutube,
	FreeResourceManage,
	BillboardManage,
	PermissionManage,
	JudgeStoriesList,
	JudgeStory,
	ManageMemberList,
	ManageMember,
	ManageSchoolList,
	ManageNotificationList,
	ManageNotification
} from "@/views";

Vue.use(Router);

export default new Router({
	mode: "history",
	routes: [
		{
			path: "/redirect",
			name: "redirect",
			meta: { authorization: true }
		},
		{
			path: "/", //初版首頁是登入頁
			name: "Login",
			component: Login
		},
		{
			path: "/forget-password",
			name: "ForgetPassword",
			component: ForgetPassword
		},
		{
			path: "/change-password",
			name: "ChangePassword",
			component: ChangePassword
		},
		{
			path: "/register",
			component: Register,
			children: [
				{
					path: "",
					name: "Register",
					component: RegisterNew
				},
				{
					path: "confirm",
					name: "RegisterConfirm",
					component: RegisterConfirm
				},
				{
					path: "profile",
					name: "RegisterProfile",
					component: RegisterProfile
				}
			]
		},
		{
			path: "/dfcchallenge",
			name: "challenge",
			component: Challenge,
			children: [
				{
					path: "person-info",
					name: "personInfo",
					component: PersonInfo,
					meta: { roles: ["user"] }
				},
				{
					path: "my-DFC",
					name: "myDFC",
					component: MyDFC,
					meta: { roles: ["user"] }
				},
				{
					path: "sign-up/",
					component: SignUp,
					meta: { breadcrumb: "報名DFC挑戰", query: { page: 1 } },
					children: [
						{
							path: "",
							name: "signUp",
							component: StartSignUp,
							props: { page: 1 },
							meta: { roles: ["user"] }
						},
						{
							path: "set-up/under18",
							name: "set_up_under18",
							component: SetUpUnder18,
							meta: { breadcrumb: "成立小組", roles: ["user"] }
						},
						{
							path: "set-up/upper18",
							name: "set_up_upper18",
							component: SetUpUpper18,
							meta: { breadcrumb: "成立小組", roles: ["user"] }
						},
						{
							path: "set-up/password",
							name: "set_up_password",
							component: SetUpPassword,
							meta: { breadcrumb: "成立小組", roles: ["user"] }
						},
						{
							path: "edit-story/:id",
							name: "editStory",
							props: { is18: false },
							component: EditStory,
							meta: {
								breadcrumb: "編輯故事",
								roles: ["user", "visitor"],
								noLink: true
							}
						}
					]
				},
				{
					path: "free-resource",
					name: "freeResource",
					component: FreeResource,
					meta: { breadcrumb: "DFC挑戰資料包" }
				},
				{
					path: "history-stories",
					name: "historyStories",
					component: HistoryStories,
					meta: { roles: ["user"] }
				}
			]
		},
		{
			path: "/backend-manage",
			name: "backendManage",
			component: BackendManage,
			children: [
				{
					path: "stories-manage",
					name: "storiesManage",
					component: StoriesManage,
					meta: { roles: ["admin", "manager", "editor"] }
				},
				{
					path: "manage-story/:id",
					name: "manageStory",
					component: ManageStory,
					props: { is18: false },
					meta: { roles: ["admin", "manager", "editor"] }
				},
				{
					path: "upload-youtube",
					name: "uploadYoutube",
					component: UploadYoutube,
					meta: { roles: ["admin", "manager", "editor"] }
				},
				// {
				// 	path: "free-resource-manage",
				// 	name: "freeResourceManage",
				// 	component: FreeResourceManage,
				// 	meta: { roles: ["admin", "manager", "editor"] }
				// },
				{
					path: "billboard-manage",
					name: "billboardManage",
					component: BillboardManage,
					meta: { roles: ["admin", "manager", "editor"] }
				},
				{
					path: "permission-manage",
					name: "permissionManage",
					component: PermissionManage,
					meta: { roles: ["admin", "manager", "editor"] }
				},
				{
					path: "judge-stories-list",
					name: "judgeStoriesList",
					component: JudgeStoriesList,
					meta: { roles: ["admin", "judge"] }
				},
				{
					path: "judge-story/:id",
					name: "judgeStory",
					component: JudgeStory,
					props: true,
					meta: { roles: ["admin", "judge"] }
				},
				{
					path: "manage-member-list",
					name: "manageMemberList",
					component: ManageMemberList,
					meta: { roles: ["admin", "manager", "editor"] }
				},
				{
					path: "manage-member/:id",
					name: "manageMember",
					component: ManageMember,
					meta: { roles: ["admin", "manager", "editor"] }
				},
				{
					path: "manage-notification-list",
					name: "manageNotificationList",
					component: ManageNotificationList,
					meta: { roles: ["admin", "manager", "editor"] }
				},
				{
					path: "new-notification",
					name: "newNotification",
					component: ManageNotification,
					meta: { roles: ["admin", "manager", "editor"] }
				},
				{
					path: "manage-notification/:id",
					name: "manageNotification",
					component: ManageNotification,
					meta: { roles: ["admin", "manager", "editor"] }
				},
				{
					path: "manage-school-list",
					name: "manageSchoolList",
					component: ManageSchoolList,
					meta: { roles: ["admin", "manager", "editor"] }
				},
			]
		}
	]
});
